<template>
    <form-input
            :name="data.slug"
            :slug="data.slug"
            :label="data.label"
            :value="data.value"
            :placeholder="$t('frontend-common.search')"
    ></form-input>
</template>

<script>
  import CatalogDynamicFilter from 'rubinred/catalog/js/mixins/CatalogDynamicFilter';

  export default {
    mixins: [CatalogDynamicFilter],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/extensions/rubinred/catalog/assets/js/components/CatalogSearchFilter.vue